import { render, staticRenderFns } from "./review-image-dialog.vue?vue&type=template&id=154431d7&scoped=true&"
import script from "./review-image-dialog.vue?vue&type=script&lang=js&"
export * from "./review-image-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154431d7",
  null
  
)

export default component.exports